<template>
  <v-card>
    <v-form ref="form_externaly" v-on:submit.prevent>
      <v-card-text>
        <v-container fluid class="pa-2 pa-sm-4">

          <!-- Verein Section -->
          <v-card outlined class="mb-4">
            <v-card-subtitle class="pb-2">Externer Verein</v-card-subtitle>
            <v-card-text>
              <v-text-field
                label="Verein"
                v-model="external_club_name"
                outlined
                dense
                hide-details="auto"
                class="mb-3"
              ></v-text-field>

              <v-text-field
                v-model="newShootingBook.Place"
                label="Bahn"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-card-text>
          </v-card>

          <!-- Aktivität Section -->
          <v-card outlined class="mb-4">
            <v-card-subtitle class="pb-2">Aktivität</v-card-subtitle>
            <v-card-text>
              <v-select
                v-model="newShootingBook.aktivitaet"
                :items="comp_OpenShootingBookData_Trainingart"
                item-text="Aktivität"
                item-value="id"
                label="Aktivität"
                value=""
                return-object
                outlined
                dense
                hide-details="auto"
                :disabled="disabledSelects"
                :rules="[rules.required]"
                :error-messages="errorMessages"
              >
                <template slot="selection" slot-scope="data">
                  {{ data.item.aktivitaet }}
                </template>
                <template slot="item" slot-scope="data">
                  {{ data.item.aktivitaet }}
                </template>
              </v-select>
            </v-card-text>
          </v-card>

          <!-- Waffe, Disziplin & Zeit Section -->
          <v-card outlined class="mb-4">
            <v-card-subtitle class="pb-2">Waffe, Disziplin & Zeitpunkt</v-card-subtitle>
            <v-card-text>
              <v-tabs v-model="weaponTab" dense grow class="mb-3">
                <v-tab class="text-none">Meine Waffen</v-tab>
                <v-tab v-if="comp_hauptverein_has_weaponpool" class="text-none">Waffenpool 🎯</v-tab>
              </v-tabs>

              <v-tabs-items v-model="weaponTab">
                <v-tab-item>
                  <v-select
                    v-if="comp_OpenShootingBookData_CountOwnWeapons > 0"
                    v-model="newShootingBook.OwnWeapon"
                    :items="comp_OpenShootingBookData_OwnWeapons"
                    item-text="Waffe"
                    item-value="id"
                    label="Eigene Waffe"
                    value=""
                    return-object
                    outlined
                    dense
                    hide-details="auto"
                    class="mb-3 weapon-dropdown-spacing"
                    :disabled="disabledSelects"
                    :rules="[v => weaponTab !== 0 || !!(v && v.id) || 'Pflichtfeld.']"
                  >
                    <template slot="selection" slot-scope="data">
                      {{ data.item.KurzT }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.KurzT }}
                    </template>
                  </v-select>
                  <v-alert
                    v-else
                    type="info"
                    dense
                    text
                    class="mt-2 mb-2"
                  >
                    Du hast noch keine eigenen Waffen hinterlegt.
                    <template v-if="comp_hauptverein_has_weaponpool">
                      Bitte wechsle zum Tab <strong>Waffenpool</strong>, um eine Waffe deines Hauptvereins zu nutzen.
                    </template>
                    <template v-else>
                      Gehe zu <a href="/user/weapon">Meine Waffen</a>, um eine Waffe hinzuzufügen.
                    </template>
                  </v-alert>
                </v-tab-item>
                <v-tab-item v-if="comp_hauptverein_has_weaponpool">
                  <v-select
                    v-if="comp_weaponPool.length > 0"
                    v-model="selectedPoolWeapon"
                    :items="comp_weaponPool"
                    item-text="id"
                    item-value="id"
                    label="Pool-Waffe auswählen"
                    return-object
                    outlined
                    dense
                    hide-details="auto"
                    class="mb-3 weapon-dropdown-spacing"
                    :disabled="disabledSelects"
                    :rules="[v => weaponTab !== 1 || !!v || 'Bitte eine Pool-Waffe wählen.']"
                  >
                    <template slot="selection" slot-scope="data">
                      <div v-if="data.item && data.item.weapon" class="d-flex flex-column py-1 pool-weapon-selection">
                        <span class="font-weight-medium text-truncate">
                          {{ data.item.weapon.hersteller }} {{ data.item.weapon.kurz_bezeichnung }}
                        </span>
                        <span class="text-caption grey--text text--darken-2 text-truncate">
                          <v-icon x-small>{{ data.item.owner_type === 'club' ? 'mdi-domain' : 'mdi-account' }}</v-icon>
                          {{ data.item.owner_name }}
                        </span>
                      </div>
                    </template>
                    <template slot="item" slot-scope="data">
                      <v-list-item-content v-if="data.item && data.item.weapon">
                        <v-list-item-title>{{ data.item.weapon.hersteller }} {{ data.item.weapon.kurz_bezeichnung }}</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ data.item.weapon.kaliber }} -
                          <v-icon x-small>{{ data.item.owner_type === 'club' ? 'mdi-domain' : 'mdi-account' }}</v-icon>
                          {{ data.item.owner_name }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                  <v-alert
                    v-else
                    type="info"
                    dense
                    text
                    class="mt-2 mb-2"
                  >
                    Im Waffenpool deines Hauptvereins ist aktuell keine Waffe verfügbar.
                  </v-alert>
                </v-tab-item>
              </v-tabs-items>

              <v-alert
                v-if="comp_show_discipline_fallback_hint"
                type="warning"
                dense
                text
                class="mb-3"
              >
                <template v-if="weaponTab === 0">
                  Keine Disziplin an dieser Waffe hinterlegt — bitte manuell wählen
                  oder unter <a href="/user/weapon">Meine Waffen</a> ergänzen.
                </template>
                <template v-else>
                  Dieser Pool-Waffe ist keine Disziplin zugeordnet — bitte manuell wählen.
                </template>
              </v-alert>

              <DisciplinePicker
                v-model="newShootingBook.Disziplin"
                :weapon-items="comp_weapon_disciplines_sorted"
                :all-items="comp_all_disciplines"
                class="mb-3"
                :disabled="disabledSelects"
                :rules="[v => (v && Object.keys(v).length > 0) || 'Pflichtfeld.']"
                :error-messages="errorMessages"
              />

              <v-dialog
                v-model="dateMenu"
                width="290px"
                :retain-focus="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="comp_BeginDateFormatted"
                    label="Datum"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    hide-details="auto"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newShootingBook.BeginDate"
                  locale="de"
                  :first-day-of-week="1"
                  scrollable
                  @input="dateMenu = false"
                ></v-date-picker>
              </v-dialog>
            </v-card-text>
          </v-card>

          <!-- Ergebnisse Section -->
          <v-card outlined class="mb-4">
            <v-card-subtitle class="pb-2">Ergebnisse</v-card-subtitle>
            <v-card-text>
              <v-text-field
                label="Schuss"
                v-model="external_Schuss"
                outlined
                dense
                hide-details="auto"
                class="mb-3"
                type="number"
                min="1"
                max="5000"
              ></v-text-field>

              <v-text-field
                label="Ergebnis"
                v-model="external_TrGes"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="px-4 py-3">
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          block
          large
          @click="save_externaL_shootingbook()"
        >
          <v-icon left>far fa-save</v-icon>
          Sichern
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import DisciplinePicker from "@/views/component/DisciplinePicker.vue";
import { sortDisciplines } from "@/views/component/disciplineUtils";

export default {
  name: "recordshootingtime_form_externaly",
  components: { DisciplinePicker },
  data: () => ({
    menu: false,
    menu2: false,
    dateMenu: false,
    tab: null,
    external_club_name: "",
    external_TrGes: "",
    external_Schuss: "",
    disabledSelects: false,
    disabledSelectsSL: false,
    newShootingBook: {
      shootingAction: { function: "Schütze", value: 1 },
      aktivitaet: { id: 1 },
      ClubRange: {},
      OwnWeapon: {},
      Disziplin: {},
      BeginDate: new Date().toISOString().slice(0, 10),
      Place: null,
      Verein: null
    },
    WeaponDiszi: [],
    textFieldProps: {
      outlined: true
    },
    textFieldPropsCustom: {
      outlined: true,
      dense: true,
      hideDetails: "auto"
    },
    datePickerProps: {},
    timePickerProps: {
      format: "24hr"
    },
    signature_style: { border: "black 3px solid" },
    rules: {
      required: value => !!value || "Pflichtfeld.",
      counter: value => value.length <= 200 || "Max 200 Zeichen",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Ungültige E-Mail.";
      }
    },
    formHasErrors: false,
    errorMessages: "",
    weaponTab: 0,
    selectedPoolWeapon: null,
    poolWeaponDisciplines: [],
    poolDisciplinesLoading: false,
    poolDisciplinesRequest: 0
  }),
  computed: {
    comp_OpenShootingBookData_OwnWeapons() {
      return this.$store.state.UserApp.Weapons || [];
    },
    comp_OpenShootingBookData_CountOwnWeapons() {
      return this.comp_OpenShootingBookData_OwnWeapons.length;
    },
    comp_OpenShootingBookData_Trainingart() {
      const data = this.$store.state.UserApp.OpenShootingBookData;
      return (data && data.trainingart) ? data.trainingart : [];
    },
    // Extern ist nur der Pool des Hauptvereins erlaubt – nicht der irgendeines Vereins
    comp_hauptverein() {
      const clubs = this.$store.state.UserApp.Clubs;
      if (clubs && Array.isArray(clubs.defVerein) && clubs.defVerein.length > 0 && clubs.meineVereine) {
        const defId = clubs.defVerein[0].defaultVerein;
        return clubs.meineVereine.find(v => v.id === defId) || null;
      }
      return null;
    },
    comp_hauptverein_has_weaponpool() {
      return !!this.comp_hauptverein && this.comp_hauptverein.has_weapon_pool === true;
    },
    comp_weaponPool() {
      return this.$store.getters["UserApp/weaponPoolHauptverein"] || [];
    },
    comp_selected_weapon_id() {
      return this.weaponTab === 0
        ? (this.newShootingBook?.OwnWeapon?.id || null)
        : (this.selectedPoolWeapon ? this.selectedPoolWeapon.weapon_id : null);
    },
    // Eigene Waffen bringen ihre Disziplinen in UserApp.Weapons mit, Poolwaffen werden nachgeladen
    comp_weapon_disciplines_sorted() {
      const list = this.weaponTab === 0
        ? this.$store.getters["UserApp/weapon_Disciplines"](this.comp_selected_weapon_id)
        : this.poolWeaponDisciplines;
      return sortDisciplines(list);
    },
    comp_selected_weapon_has_disciplines() {
      return this.comp_weapon_disciplines_sorted.length > 0;
    },
    comp_BeginDateFormatted() {
      if (!this.newShootingBook.BeginDate) return "";
      const [y, m, d] = this.newShootingBook.BeginDate.split("-");
      return `${d}.${m}.${y}`;
    },
    comp_all_disciplines() {
      return this.$store.state.UserApp.Discipline || [];
    },
    comp_show_discipline_fallback_hint() {
      return !!this.comp_selected_weapon_id
        && !this.comp_selected_weapon_has_disciplines
        && !this.disabledSelects
        && !this.poolDisciplinesLoading;
    }
  },

  watch: {
    weaponTab() {
      this.applyDefaultDisziplin();
    },
    "newShootingBook.OwnWeapon"() {
      if (this.weaponTab === 0) {
        this.applyDefaultDisziplin();
      }
    },
    selectedPoolWeapon() {
      this.loadPoolWeaponDisciplines();
    },
    // immediate: Vereinsdaten können auch erst nach dem Mounten eintreffen
    comp_hauptverein_has_weaponpool: {
      immediate: true,
      handler(hasPool) {
        if (hasPool) {
          this.$store.dispatch("UserApp/fetchPoolWeaponsHauptverein");
          if (this.comp_OpenShootingBookData_CountOwnWeapons === 0) {
            this.weaponTab = 1;
          }
        } else {
          this.$store.commit("UserApp/SET_WEAPON_POOL_HAUPTVEREIN", []);
          this.weaponTab = 0;
          this.selectedPoolWeapon = null;
        }
      }
    }
  },

  created() {
    this.on_created();
  },

  methods: {

    on_created() {
      this.$store.dispatch("UserApp/ensureDisciplines");
      this.newShootingBook.OwnWeapon = this.$store.state.UserApp.Weapons[0] || {};
      this.applyDefaultDisziplin();
    },

    // Disziplinen der Poolwaffe nachladen – der Getter weapon_Disciplines kennt nur eigene Waffen
    async loadPoolWeaponDisciplines() {
      const weaponId = this.selectedPoolWeapon ? this.selectedPoolWeapon.weapon_id : null;
      const request = ++this.poolDisciplinesRequest;
      this.poolDisciplinesLoading = !!weaponId;
      let list = [];
      if (weaponId) {
        try {
          list = await this.$store.dispatch("UserApp/fetchWeaponDisciplines", weaponId);
        } catch (error) {
          list = [];
        }
      }
      // Eine ältere, langsamere Antwort darf die zur neu gewählten Waffe nicht überschreiben
      if (request !== this.poolDisciplinesRequest) return;
      this.poolWeaponDisciplines = list;
      this.poolDisciplinesLoading = false;
      if (this.weaponTab === 1) {
        this.applyDefaultDisziplin();
      }
    },

    // Vorbelegt wird nur aus den Disziplinen der Waffe – nie irgendeine aus dem Gesamtkatalog
    applyDefaultDisziplin() {
      this.newShootingBook.Disziplin = this.comp_selected_weapon_has_disciplines
        ? this.comp_weapon_disciplines_sorted[0]
        : {};
    },

    async save_externaL_shootingbook() {
      // comp_selected_weapon_id deckt auch den Fall "Tab Meine Waffen ohne eigene Waffen" ab
      if (!this.$refs.form_externaly.validate() || !this.comp_selected_weapon_id) {
        return;
      }
      const fromPool = this.weaponTab === 1;
      let Data = {
        ext_clubname: this.external_club_name,
        inputTrainingArt: this.newShootingBook.aktivitaet.id,
        inputDisz: this.newShootingBook.Disziplin.id,
        // bei Pool-Waffe setzt das Backend die Waffe selbst, inputWaffe wird ignoriert
        inputWaffe: fromPool ? null : this.newShootingBook.OwnWeapon.id,
        weapon_pool_id: fromPool ? this.selectedPoolWeapon.id : null,
        inputPlatz: this.newShootingBook.Place,
        datum: this.parseDateInput(this.newShootingBook.BeginDate),
        trergges: this.external_TrGes,
        anz_schuss: this.external_Schuss
      };
      try {
        await this.$store.dispatch("UserApp/setNewExternalShootingBookRecord", Data);
      } catch (error) {
        // Fehler wurde bereits angezeigt, Eingaben bleiben erhalten
        return;
      }
      this.set_defaultInputs();
    },
    parseDateInput(value) {
      if (!value) return new Date();
      const [y, m, d] = value.split("-").map(Number);
      return new Date(y, m - 1, d, 0, 0, 0);
    },
    set_defaultInputs() {
      this.external_club_name = "";
      this.external_TrGes = "";
      this.external_Schuss = "";
      this.newShootingBook = {
        shootingAction: { function: "Schütze", value: 1 },
        aktivitaet: { id: 1 },
        OwnWeapon: this.$store.state.UserApp.Weapons[0] || {},
        Disziplin: {},
        BeginDate: new Date().toISOString().slice(0, 10),
        Place: null
      };
      this.selectedPoolWeapon = null;
      this.applyDefaultDisziplin();
      this.$nextTick(() => this.$refs.form_externaly.resetValidation());
    }
  }
};
</script>

<style scoped>
.weapon-dropdown-spacing {
  margin-top: 5px;
}
.pool-weapon-selection {
  min-width: 0;
  max-width: 100%;
  flex: 1 1 auto;
  line-height: 1.2;
}
.pool-weapon-selection > span {
  display: block;
  min-width: 0;
}
/* v-autocomplete: Suchfeld vertikal mittig zur 2-zeiligen Selection ausrichten */
::v-deep .v-select__slot input {
  align-self: center;
}
/* Mobile optimization */
@media (max-width: 600px) {
  .v-card__subtitle {
    font-size: 0.875rem;
    font-weight: 600;
  }
}
</style>